export default "__VITE_ASSET__DpZhV5tx__"